import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import corporateSelector from 'modules/Auth/selectors'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'
import request from 'utils/request'

export const SET_USER_METRICS = 'corporate/SET_USER_METRICS'
export const SET_USER_LIST = 'corporate/SET_USER_LIST'
export const SET_SINGLE_USER = 'corporate/SET_SINGLE_USER'

export const setUserMetrics = data => {
  return {
    type: SET_USER_METRICS,
    data,
  }
}

export const setUserList = data => {
  return {
    type: SET_USER_LIST,
    data,
  }
}

export const setSingleUser = data => {
  return {
    type: SET_SINGLE_USER,
    data,
  }
}

export const getUserMetrics = () => async (dispatch, getState) => {
  try {
    const state = getState()
    const coporateId = corporateSelector.getCorporateId(state)
    const response = await request.get(
      `/users/metrics?corporateID=${coporateId}`
    )
  
    dispatch(setUserMetrics(response || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getUserList =
  ({ searchValue, sortBy, userRoleValue, userStatus, pageNum }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)

      const search = searchValue ? `&search=${searchValue?.trim()}` : ''

      const sortKey = sortBy?.columnKey ? `&sortBy=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''
      const userRole = userRoleValue?.length > 0 ? `&Role=${userRoleValue}` : ''
      const status = userStatus?.length > 0 ? `&status=${userStatus}` : ''

      const response = await request.get(
        `/user?pageLimit=10&currentPage=${pageNum}&coporateId=${coporateId}${sortKey}${sortOrder}${search}${userRole}${status}`
      )
     
      dispatch(setUserList(response?.data?.data))
      return response?.data?.data
    } catch (error) {
      return error
    }
  }

export const createUser =
  ({ payload }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      let updatedPayload = {
        ...payload,
        corporateId: coporateId,
        journey: 'CORPORATE',
      }

      const response = await request.post(`/user`, updatedPayload)
      return response
    } catch (error) {
      return error
    }
  }

export const getSingleUser =
  ({ userId }) =>
  async dispatch => {
    try {
      const response = await request.get(`/user/${userId}`)
      dispatch(setSingleUser(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const updateUser =
  ({ userId, payload }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      let updatedPayload = {
        ...payload,
        corporateId: coporateId,
      }

      const response = await request.put(`/user/${userId}`, updatedPayload)

      return response
    } catch (error) {
      return error
    }
  }

export const updateUserStatus =
  ({ userId, status }) =>
  async () => {
    try {
      const response = await request.patch(`/user/${userId}/status`, {
        status: status,
      })
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage(
          status
            ? 'User activated successfully!'
            : 'User inactivated successfully!'
        )
      }
      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const deleteUser =
  ({ userId }) =>
  async () => {
    try {
      const response = await request.delete(`/user/${userId}`)
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('User Deleted Successfully!')
      }
      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)

      return error
    }
  }
export const getNotificationCatalogues = (eventId, subEventID) => async () => {
  let event = eventId ? `eventId=${eventId}` : ''
  let subEvent = subEventID ? `subEventId=${subEventID}` : ''

  try {
    const result = await adminRequest.get(
      `notificationCatalogue?${event}${subEvent}`
    )
    return result?.data?.data
  } catch (error) {
    //
  }
}

export const sendNotificationEmail = payload => async () => {
  try {
    await request.post(`/notification/email`, payload)
  } catch (error) {
    return error
  }
}

export const sendNotificationBulkEmail = payload => async () => {
  try {
    await request.post(`/notification/bulkEmail`, payload)
  } catch (error) {
    return error
  }
}

export const sendNotificationBulkEmailWhatsapp = payload => async () => {
  try {
    await request.post(`/notification/bulkWhatsapp`, payload)
  } catch (error) {
    return error
  }
}
export const sendNotificationWhatsapp = payload => async () => {
  try {
    await request.post(`/notification/whatsapp`, payload)
  } catch (error) {
    return error
  }
}

/**
 * Assessment WhatsApp notifications, gated on the corporate's subscription.
 *
 * These are built and posted here rather than on a backend, so there is no
 * server-side choke point to gate them at — the check has to happen before the
 * dispatch. Deliberately separate from sendNotificationBulkEmailWhatsapp: that
 * one also carries interview-scheduling messages, which are out of scope for the
 * assessment subscription and must keep sending.
 *
 * Fails CLOSED to match the backend gates: if the flag cannot be read we send
 * nothing, because sending to an unsubscribed corporate's candidates is the
 * failure we are fixing.
 */
export const sendAssessmentWhatsapp = payload => async (dispatch, getState) => {
  try {
    const corporateId = corporateSelector.getCorporateId(getState())
    if (!corporateId) return null

    const { data } = await request.get(
      `/corporates/${corporateId}/feature-access`
    )
    if (!data?.data?.WHATSAPP_NOTIFICATION) return null

    await request.post(`/notification/bulkWhatsapp`, payload)
    return true
  } catch (error) {
    return error
  }
}

export const sendInAppNotification = payload => async () => {
  try {
    await request.post(`/users/createNotification`, payload)
  } catch (error) {
    return error
  }
}

export const getUserCorpList = corpId => async () => {
  try {
    const response = await request.get(
      `/user?instituteCampusId=${corpId}&status=true`
    )
    // SuccessMessage('Updated Successfully')
    return response?.data?.data
  } catch (error) {
    //
  }
}
